import styles from './index.module.sass';
import RadioGroup from '@pklot/mochi-component/lib/radio-group';
import TextInput from 'componets/text-input';
import { energySources, vehicleTypes, electricVehicleTypes, oilTypes } from 'config/vehicle';
import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

const EditLicensePlate = ({
  isEdit,
  title,
  plate,
  plateErrorMessage,
  onPlateChange,
  onPlateFocus,
  energySource,
  onEnergySourceSelect,
  vehicleType,
  onVehicleTypeSelect,
  oilType,
  onOilTypeSelect,
  oilError,
}) => {
  const vehicleTypesList = [
    {
      id: 'select-consume-type',
      name: '動力類型',
      data: energySources.map(item => ({ ...item, isChecked: item.id === energySource })),
      groupName: 'energySource',
      type: energySource,
      onChange: onEnergySourceSelect,
    },
    {
      id: 'select-electric-vehicle-type',
      name: '車種',
      data: electricVehicleTypes.map(item => ({ ...item, isChecked: item.id === vehicleType })),
      groupName: 'eletricVehicleType',
      type: vehicleType,
      onChange: onVehicleTypeSelect,
    },
    {
      id: 'select-vehicle-type',
      name: '車種',
      data: vehicleTypes.map(item => ({ ...item, isChecked: item.id === vehicleType })),
      groupName: 'vehicleType',
      type: vehicleType,
      onChange: onVehicleTypeSelect,
    },
    {
      id: 'select-oil-type',
      name: '油品',
      data: oilTypes.map(item => ({ ...item, isChecked: item.id === oilType })),
      groupName: 'oilType',
      type: oilType,
      onChange: onOilTypeSelect,
    },
  ];

  return (
    <>
      <div className={styles.title}>{title}</div>
      {!isEdit && (
        <div className={styles['form-input']}>
          <label className={styles['form-label']}>付款車牌</label>
          <TextInput
            placeholder="輸入車牌（包含 - 橫線）"
            newText={plate}
            isInvalid={!!plateErrorMessage}
            errorMessage={plateErrorMessage}
            onTextChange={onPlateChange}
            textAllCaps={true}
            maxLength={8}
            onFocus={onPlateFocus}
          />
        </div>
      )}
      {vehicleTypesList.map(item => {
        const hideWithOilOptions = energySource === 'fuel' && item.id === 'select-electric-vehicle-type';
        const hideWithElectricOptions =
          energySource === 'electric' && (item.id === 'select-vehicle-type' || item.id === 'select-oil-type');

        if (hideWithOilOptions || hideWithElectricOptions) return <div key={item.id} />;

        return (
          <div className={styles['form-input']} key={item.id}>
            <label className={styles['form-label']}>{item.name}</label>
            <RadioGroup
              column={1}
              data={item.data}
              name={item.groupName}
              onChange={list => {
                const selectedItemId = list.find(x => x.isChecked).id;
                item.onChange(selectedItemId);
              }}
              style={{ margin: '5px 15px 0 0' }}
            />
          </div>
        );
      })}
      <div className={cx({ radioError: true, show: !!oilError })}>{oilError}</div>
    </>
  );
};

export default EditLicensePlate;
